// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2Alua","footer":"ModalUpdate_footer__2cBYm"};